import { QueryKey } from '@tanstack/react-query';
import { Integration } from 'models/InternalIntegrationSetting';
import useEnableIntegrationMutation from 'pages/integrations/hooks/useEnableIntegrationMutation';
import { INTEGRATIONS_WITH_CUSTOM_ACTIVATION_MODAL } from 'pages/integrations/IntegrationsTabs.constants';
import useEnableCustomIntegrationModal from 'pages/integrations/modals/enableCustomIntegrationModal/useEnableCustomIntegrationModal';
import { IntegrationMutationLevel } from 'pages/integrations/hooks/useDisableIntegrationMutation';

const useActivateIntegration = () => {
  const { enableIntegration } = useEnableIntegrationMutation();
  const { openCustomIntegrationModal } = useEnableCustomIntegrationModal();

  const handleActivateIntegration = ({
    integration,
    queryKey,
    onSuccess,
  }: {
    integration: Integration;
    queryKey: QueryKey;
    onSuccess?: () => void;
  }) => {
    if (
      INTEGRATIONS_WITH_CUSTOM_ACTIVATION_MODAL.includes(
        integration.enumId as (typeof INTEGRATIONS_WITH_CUSTOM_ACTIVATION_MODAL)[number],
      )
    ) {
      openCustomIntegrationModal({ integration, queryKey });
      return;
    }

    // Send the request to enable the integration at the agency level
    enableIntegration(
      {
        level: IntegrationMutationLevel.AGENCY,
        enumId: integration.enumId,
        queryKey,
      },
      {
        onSuccess,
      },
    );
  };

  return {
    handleActivateIntegration,
  };
};

export default useActivateIntegration;
